import {Component, EventEmitter, OnDestroy, OnInit} from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import {HeaderService} from '../../core/services/header.service';
import {Title} from '@angular/platform-browser';
import {BaseComponent} from '../../core/base.component';
import {AuthService} from '../../core/security/auth.service';
import {RolesEnum} from '../../core/security/roles.enum';
import {RouterHelper} from '../../core/utilities/router-helper';
import {FilterOptionModel} from '../../dialogs/grid-filter/filter-option.model';
import {PhoneNumbersUtils} from '../../core/utilities/phone-numbers-helpers';
import {LookupModel} from '../../api/models/lookup-model';
import {ProMessagingAutomationService} from '../pro-messaging-automation.service';
import { FlexModule } from '@angular/flex-layout';
import { GridFilterComponent } from '../../dialogs/grid-filter/grid-filter.component';
import { FilterRowAdditionalContentComponent } from '../../dialogs/grid-filter/filter-row-additional-content.component';
import { NgIf } from '@angular/common';
import { MatAnchor } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { AutomationListGridComponent } from './grid/automation-list-grid.component';

@Component({
    selector: 'app-pro-messaging-automation-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        GridFilterComponent,
        FilterRowAdditionalContentComponent,
        NgIf,
        MatAnchor,
        MatTooltip,
        RouterLink,
        AutomationListGridComponent,
    ],
})
export class ProMessagingAutomationListComponent extends BaseComponent implements OnInit, OnDestroy {

  filterOptions: FilterOptionModel[] = [];
  filterChangeEvent = new EventEmitter<any>();

  detailsUrl: string;
  additionalFilter: any = {};
  buttonSubmitPromise: Promise<void>;
  availablePhoneNumbers: LookupModel[] = [];
  private paramsSubscription;


  constructor(route: ActivatedRoute, headerService: HeaderService, titleService: Title, authService: AuthService,
              public automationService: ProMessagingAutomationService,) {
    super(route, headerService, titleService, authService);

    const detailsModule = RouterHelper.getRouteByComponent('ProMessagingAutomationEditComponent');
    this.detailsUrl = this.headerService.themePrefix + detailsModule.path.replace('/edit', '');
    console.log(this.detailsUrl);

    this.editRoles = [RolesEnum.MessagingAutomation_Edit, RolesEnum.MessagingAutomation_Delete];
    this.deleteRoles = [RolesEnum.MessagingAutomation_Delete];
  }

  ngOnInit() {
    super.ngOnInit();
    this.headerService.showBackButton(true);
    this.automationService.lookupPhoneNumbers().then((numbers) => {
      this.availablePhoneNumbers = numbers;
      this.initFilterOptions();
    })
  }

  onFilterChanged(filter: any) {
    this.filterChangeEvent.emit(filter);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.paramsSubscription?.unsubscribe();
    this.headerService.hideSearchInput();
    this.headerService.showBackButton(false);
  }

  initFilterOptions(): void {
    this.filterOptions = [
      {
        filterKey: 'searchText',
        multiValue: false,
        showAlways: true,
        type: 'string',
        title: 'Any'
      },
      {
        filterKey: 'name',
        multiValue: false,
        showAlways: true,
        type: 'string',
        title: 'Name'
      },
      {
        filterKey: 'replyMessage',
        multiValue: false,
        showAlways: true,
        type: 'string',
        title: 'Reply Message'
      },
      {
        filterKey: 'isEnabled',
        multiValue: false,
        showAlways: false,
        type: 'static',
        title: 'Enabled',
        displayValue: 'Yes',
        value: true,
        searchText: 'Enabled: Yes',
      },
      {
        filterKey: 'isEnabled',
        multiValue: false,
        showAlways: false,
        type: 'static',
        title: 'Enabled',
        displayValue: 'No',
        value: false,
        searchText: 'Enabled: No',
      },
    ];

    if (this.availablePhoneNumbers.length > 0) {
      for (const item of this.availablePhoneNumbers) {
        this.filterOptions.push({
          filterKey: 'phoneNumbers',
          multiValue: true,
          showAlways: false,
          type: 'static',
          title: 'Phone Number',
          displayValue: `${PhoneNumbersUtils.format(item.text)}`,
          value: item.text,
          searchText: `Phone Number: ${PhoneNumbersUtils.phoneNumberToNational(item.text)} ${PhoneNumbersUtils.format(item.text)}`,
        });
      }
    }
  }
}
